CustomTC.define('jquery/var/indexOf',[
	"./arr"
], function( arr ) {
	return arr.indexOf;
});

